// extracted by mini-css-extract-plugin
export var content = "content__f2B6";
export var fakeButtons1 = "fake-buttons1__bL18";
export var fakeButtons2 = "fake-buttons2__fuCD";
export var fakeFilter = "fake-filter__yLJt";
export var fakeTab = "fake-tab__wVrO";
export var fakeTabContainer = "fake-tab-container__IWe4";
export var layout = "layout__it8K";
export var rating = "rating__PNJM";